<template>
  <div v-resize="onSizeChange">
    <v-navigation-drawer v-if="!isSharepointList" width="175" v-model="drawer" app :mini-variant.sync="mini" permanent> <!-- :mini-variant="true" :expand-on-hover="true" -->
      <!-- <v-card class="mx-auto" tile>
        <v-img class="image-auto-size mr-4" height="50" contain :src="require('../../public/images/logo.png')"></v-img>
      </v-card> -->
      <v-list-item class="px-2">
        <v-list-item-avatar class="mr-2">
          <v-img :src="appObj.logo"></v-img>
        </v-list-item-avatar>
        <v-list-item-title>{{ appObj.name }}</v-list-item-title>
        <v-btn icon  @click.stop="mini = !mini" >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>
      <p :class="!mini ? 'ma-1' : 'mb-1'" v-if="showRunningTimer">
        <v-progress-linear indeterminate v-if="timerLoading" color="primary darken-2" ></v-progress-linear>
        <v-chip outlined label :class="!mini ? 'title pa-2' : 'caption pa-0'">
          <v-icon left v-if="!mini">mdi-timer</v-icon>
            <span>{{ runningTime }}</span>
        </v-chip>
      </p>
      <v-divider></v-divider>
      <v-list dense>
        <template mplate v-for="(item, index) in listOfMenu">
          <template v-if="item.isSettings && isUserAdmin">
            <v-divider :key="`${index}_divider`"></v-divider>
            <v-subheader class="subtitle-2" :key="`${index}_settings`">{{ $t('message.layout.settings') }}</v-subheader>
          </template>
          <v-list-item :key="`${index}_list`" v-if="!item.hasChildren && item.isSettingItem ? item.isSettingItem && isUserAdmin : true" :to="item.to">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-group v-else-if="item.isSettingItem ? item.isSettingItem && isUserAdmin : true" :key="`${index}_children`" :prepend-icon="item.icon" append-icon="mdi-chevron-down">
            <template v-slot:activator>
              <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
            </template>
            <v-list-item v-for="subItem in item.children" class="ml-3" :key="subItem.title" :to="subItem.to">
              <v-list-item-action>
                <v-icon>{{ subItem.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ $t(subItem.title) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>
      <template v-slot:append>
        <v-list dense>
          <v-menu transition="slide-x-transition" offset-y>
            <template v-slot:activator="{ on }">
              <v-list-item v-on="on">
                <v-list-item-icon>
                  <v-icon>mdi-translate</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
              <v-list-item-title>{{ $t('message.common.translate') }}</v-list-item-title>
            </v-list-item-content>
              </v-list-item>
            </template>
              <v-list>
              <v-list-item-group color="primary">
                <v-list-item
                  v-for="(item, i) in langItem"
                  :key="i" @click="changeLang(item.value)" id="select_lang"
                >
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
          <v-list-item link @click="menuActions('logout')">
            <v-list-item-icon>
              <v-icon>mdi-exit-to-app</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('message.layout.logout') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item></v-list-item>
        </v-list>
      </template>
      <v-fab-transition>
          <v-btn fab bottom x-small left color="primary"  fixed @click="openInNewTab()">
            <v-icon dark>mdi-open-in-new</v-icon>
          </v-btn>
        </v-fab-transition>
    </v-navigation-drawer>
    <!-- DELETE WARNING -->
    <v-dialog v-model="showDialog" persistent max-width="400px" class="mt-0">
      <v-card>
        <v-card-title>
          {{ $t('message.common.deleteConfirm') }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          {{ $t('message.common.areYouSure') }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" id="deleteConfirm" :loading="loading" @click="confirmDelete">{{ $t('message.common.yes') }}</v-btn>
          <v-btn color="primary" id="deleteClose" @click="showDialog=false">{{ $t('message.common.no') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import menuList from './menus'
import _localStorage from '@/plugins/local_storage'
export default {
  data () {
    return {
      drawer: true,
      mini: false,
      items: [{ title: 'message.layout.logout', click: 'logout' }],
      listName: '',
      listDefault: false,
      loading: false,
      on: true,
      globalSearchTerm: null,
      appObj: {},
      webWorkerInstance: null,
      runningTime: '00:00:00',
      timerLoading: false,
      activeUser: {}
    }
  },
  computed: {
    ...mapGetters(['showDialog', 'getuserDetails', 'deletePayload', 'timerData']),
    listOfMenu () {
      let list = this.$format.cloneVariable(menuList)
      return list
      /* if (!this.getuserDetails.isadmin) {
        list.splice((list.length - 1), 1)
        return list
      } else return list */
    },
    showDialog: {
      get () {
        return this.$store.getters.showDialog
      },
      set (val) {
        if (!val) this.$store.commit('hideDialog')
      }
    },
    getURL () {
      let url = process.env.VUE_APP_URL
      return url.split('/api')[0]
    },
    isUserAdmin () {
      let getActiveuser = _localStorage.get(process.env.VUE_APP_USER) // this.$cookie.get(process.env.VUE_APP_USER)
      let user = getActiveuser ? JSON.parse(getActiveuser) : {}
      return user.isadmin ? user.isadmin : false
    },
    langItem () {
      let language
      if (this.$i18n.locale === 'en') {
        language = [{ title: this.$t('message.common.norwegian'), value: 'no' }]
      } else if (this.$i18n.locale === 'no') {
        language = [{ title: this.$t('message.common.english'), value: 'en' }]
      }
      return language
    },
    showRunningTimer () {
      let isRunningOutSide = this.$store.state.common.isTimerRunning && this.$route.name !== 'stamptime'
      if (isRunningOutSide) {
        this.getRunningStemp(this.getuserDetails.id)
        return true
      } else {
        this.stopCommonTimer()
        return false
      }
    },
    isSharepointList () {
      return this.$route.name === 'projectsharepoint' || this.$route.name === 'companysharepoint'
    }
  },
  mounted () {
    this.getAppLogoAndName()
    let isRunning = window.localStorage.getItem('is_timer_running') || 'false'
    if (isRunning === 'true') this.getRunningStemp(this.getuserDetails.id)
    this.$eventBus.$on('companySettingsUpdated', (isUpdated) => {
      if (isUpdated) this.getAppLogoAndName()
    })
    this.$eventBus.$on('stopTimer', () => {
      this.stopCommonTimer()
    })
  },
  methods: {
    openInNewTab () {
      window.open('/dashboard', '_blank')
    },
    stopCommonTimer () {
      this.runningTime = '00:00:00'
      if (this.webWorkerInstance) {
        this.webWorkerInstance.terminate()
        this.webWorkerInstance = null
      }
    },
    getAppLogoAndName () {
      this.$api.execute('get', `companysettings`)
        .then((response) => {
          let model = response.data
          model.logo = `${this.getURL}/images/${model.logo}`
          this.appObj = response.data
        })
    },
    onSizeChange () {
      if (window.innerWidth <= 768) this.mini = true
    },
    confirmDelete () {
      this.loading = true
      let model = this.deletePayload
      let dispatchAction = model.isSingle ? 'deleteSingleRecordHandler' : 'deleteHandler'
      this.$store.dispatch(dispatchAction, model)
        .then(() => {
          this.$eventBus.$emit('deleteSuccess', model.module)
        }).finally(() => {
          this.loading = false
        })
    },
    menuActions (action) {
      switch (action) {
        case 'logout':
          this.$store.dispatch('logout')
          this.$router.push('/loggedout')
          break
        default:
          break
      }
    },
    changeLang (language) {
      this.$i18n.locale = language
      window.localStorage.setItem('stray_vyrje_lang', language)
      this.$eventBus.$emit('languageChanged')
    },
    reloadApp () {
      window.location.reload()
    },
    doSearchHandler (searchTerm) {
      if (this.$route.path === '/search_results') {
        this.$eventBus.$emit('updateSearchResult', searchTerm)
      } else this.$router.push(`/search_results?search_text=${searchTerm}`)
    },
    getRunningStemp () {
      this.timerLoading = true
      this.$store.dispatch('getRunningTimer', this.getuserDetails.id)
        .then((data) => {
          if (data) {
            if (data.time) {
              this.startTimer(data.time)
            }
          }
        })
    },
    startTimer (time) {
      if (!time) time = new Date()
      if (typeof (Worker) !== 'undefined') {
        if (this.webWorkerInstance === null) {
          this.webWorkerInstance = new Worker(`../../../js/timer.js?date=${time}`)
        }
        this.webWorkerInstance.onmessage = (event) => {
          this.runningTime = event.data
        }
        window.localStorage.setItem('is_timer_running', true)
        this.timerLoading = false
        this.$store.commit('setTimerValue', this.runningTime)
      } else {
        alert('Browser is not supporting web workers!')
      }
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('companySettingsUpdated')
    this.$eventBus.$off('stopTimer')
  }
}
</script>
<style lang="scss">
  @import '../assets/css/variables.scss';
  .image-auto-size .v-image__image--cover {
    background-size: auto !important;
  }
  .max-width-30-per {
    max-width: 30%;
  }
  .v-list .v-list-item--active {
    color: $layout-color !important;
  }
</style>
